export default __webpack_public_path__ + "static/media/logo-black-min.34df0313.png";